import axios from "axios";

const requests = axios.create({
    baseURL: '/api',
    timeout: 60000
});
// 请求拦截器
requests.interceptors.request.use((config) => {

    return config;

});
// 响应拦截器
requests.interceptors.response.use((res) => {

    return res.data;

}, (error) => {

    return { code: 400, message: `请求发生错误：${error}` };

});

export default requests;